import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "/assets/logo.svg";

const FirstLogin = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState({});
  const navigate = useNavigate();

  const handlePasswordConfirmation = async (e) => {
    e.preventDefault();
    setError({});

    try {
      const userData = JSON.parse(sessionStorage.getItem("userData"));
      if (!userData || !userData.email) {
        setError({ userData: "User data is missing or invalid" });
        return;
      }

      if (password === confirmPassword) {
        const response = await axios.post(
          `${import.meta.env.VITE_API_URL}/change-password-firstlogin`,
          {
            email: userData.email,
            newPassword: password,
          }
        );

        if (response.data.message === "Password changed successfully") {
          if (userData.admin) {
            navigate("/main");
          } else {
            navigate("/branch");
          }
        } else {
          setError({ passwordUpdate: "เกิดข้อผิดพลาดในการอัพเดตรหัสผ่าน" });
        }
      } else {
        setError({ passwordMatch: "รหัสผ่านไม่ตรงกัน" });
      }
    } catch (error) {
      setError({ httpRequest: "เกิดข้อผิดพลาดในการทำ HTTP request" });
    }
  };

  const renderFloatLabelInput = (
    label,
    type,
    name,
    id,
    value,
    onChange,
    required = true,
    autoComplete = "off",
    errorField
  ) => (
    <div className={`float-label-wrapper ${error[errorField] ? "error" : ""}`}>
      <input
        type={type}
        id={id}
        name={name}
        value={value || ""}
        onChange={(e) => {
          onChange(e);
          if (error[errorField]) {
            setError({ ...error, [errorField]: false }); // Clear specific error field
          }
        }}
        className="float-input"
        required={required}
        placeholder=" "
        autoComplete={autoComplete}
      />
      <label htmlFor={id} className="float-label">
        {label} {required && <span className="required-star"> *</span>}
      </label>
    </div>
  );

  return (
    <div className="background-image">
      <div className="container">
        <form className="login-form" onSubmit={handlePasswordConfirmation}>
          <div className="logo">
            <img src={logo} alt="Logo" style={{ marginRight: "8px" }} />
          </div>

          <div className="forgotPassword">
            <h2>เข้าสู่ระบบครั้งแรก</h2>
            <p>กรุณาเปลี่ยนรหัสผ่านของคุณเพื่อความปลอดภัย.</p>

            <div className="forgotPasswordInput">
              {" "}
              {renderFloatLabelInput(
                "รหัสผ่านใหม่",
                "password",
                "password",
                "new-password",
                password,
                (e) => setPassword(e.target.value),
                true,
                "new-password",
                "passwordMatch"
              )}
              {renderFloatLabelInput(
                "ยืนยันรหัสผ่านใหม่",
                "password",
                "confirmPassword",
                "confirm-password",
                confirmPassword,
                (e) => setConfirmPassword(e.target.value),
                true,
                "new-password",
                "passwordMatch"
              )}
              <div className="errorFirstlogin">
                {" "}
                {error.passwordMatch && (
                  <p className="error-message">{error.passwordMatch}</p>
                )}
                {error.userData && (
                  <p className="error-message">{error.userData}</p>
                )}
                {error.passwordUpdate && (
                  <p className="error-message">{error.passwordUpdate}</p>
                )}
                {error.httpRequest && (
                  <p className="error-message">{error.httpRequest}</p>
                )}
              </div>
            </div>

            <button type="submit" className="ok-branch-ok">
              ยืนยัน
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FirstLogin;
